import { ElementType, Template, GlobalConfig } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const createTemplate3MobileNavigationPopup = (
  globalConfig: GlobalConfig
): Template => ({
  id: "mobile-navigation",
  name: "Mobile Navigation",
  industry: "template3",
  elements: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        backgroundColor: "#FFFFFF",
        borderRadius: "0",
        padding: "0",
        margin: "0",
        width: "100vw",
        maxWidth: "100vw",
        minWidth: "100vw",
        height: "100vh",
        minHeight: "100vh",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: "9999",
      },
      children: [
        // Header with logo and close button
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            position: "relative",
            padding: "20px",
            borderBottom: "1px solid #DDD",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          children: [
            // Logo
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/logo.png",
              alt: "logo",
              styles: {
                width: "120px",
                height: "auto",
                objectFit: "contain",
              },
            },
            // Close button (X) in top-right
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='1.5' stroke='currentColor'%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18L18 6M6 6l12 12'/%3e%3c/svg%3e",
              alt: "close",
              styles: {
                position: "absolute",
                top: "20px",
                right: "20px",
                width: "24px",
                height: "24px",
                cursor: "pointer",
                color: "#333",
              },
            },
          ],
        },
        // Navigation links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            padding: "40px 20px",
            gap: "0",
            height: "calc(100vh - 140px)",
            minHeight: "calc(100vh - 140px)",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Über Klosterformel",
              styles: {
                fontFamily: "Open Sans, sans-serif",
                fontSize: "20px",
                fontWeight: "400",
                color: "#333",
                margin: "0",
                padding: "20px 0",
                textDecoration: "none",
                borderBottom: "1px solid #F0F0F0",
                cursor: "pointer",
                width: "100%",
                maxWidth: "400px",
                textAlign: "center",
              },
              interactionType: "popup",
              triggerPopup: "none",
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Preis",
              styles: {
                fontFamily: "Open Sans, sans-serif",
                fontSize: "20px",
                fontWeight: "400",
                color: "#333",
                margin: "0",
                padding: "20px 0",
                textDecoration: "none",
                borderBottom: "1px solid #F0F0F0",
                cursor: "pointer",
                width: "100%",
                maxWidth: "400px",
                textAlign: "center",
              },
              interactionType: "popup",
              triggerPopup: "none",
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Zutaten",
              styles: {
                fontFamily: "Open Sans, sans-serif",
                fontSize: "20px",
                fontWeight: "400",
                color: "#333",
                margin: "0",
                padding: "20px 0",
                textDecoration: "none",
                borderBottom: "1px solid #F0F0F0",
                cursor: "pointer",
                width: "100%",
                maxWidth: "400px",
                textAlign: "center",
              },
              interactionType: "popup",
              triggerPopup: "none",
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Häufig Gestellte Fragen",
              styles: {
                fontFamily: "Open Sans, sans-serif",
                fontSize: "20px",
                fontWeight: "400",
                color: "#333",
                margin: "0",
                padding: "20px 0",
                textDecoration: "none",
                borderBottom: "1px solid #F0F0F0",
                cursor: "pointer",
                width: "100%",
                maxWidth: "400px",
                textAlign: "center",
              },
              interactionType: "popup",
              triggerPopup: "none",
            },
            // Order Button
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Jetzt Bestellen",
              styles: {
                fontFamily: "Open Sans, sans-serif",
                fontSize: "18px",
                fontWeight: "600",
                color: "#FFFFFF",
                backgroundColor: "#1E2A1E",
                border: "none",
                borderRadius: "8px",
                padding: "18px 40px",
                cursor: "pointer",
                marginTop: "40px",
                textAlign: "center",
                width: "100%",
                maxWidth: "400px",
              },
              interactionType: "popup",
              triggerPopup: "none",
            },
          ],
        },
      ],
    },
  ],
});
